export const changeConfig = (config) => ({
    type: 'CHANGE_CONFIG',
    payload: config
});
